import { styled, Typography,
  DialogTitle as MuiDialogTitle
 } from "@mui/material";

import CareCreditLogoFull from "../../../../../../../../assets/carecredit_logo_full.svg";
import { Dialog as DialogShared } from "apps/wrapper/src/components/shared/dialog/dialog.styles";
import { LinkButton as LinkButtonShared } from "apps/wrapper/src/components/shared/buttons";

export const CareCreditLogo = styled((props: any) => <img src={CareCreditLogoFull} alt="CareCredit Logo" {...props} />)(
  () => ({
    width: '100%',
    objectFit: 'contain',
    height: 29,
    marginTop: 20,
    marginBottom: 20
  })
);

export const Dialog = styled(DialogShared)({
  '.MuiDialog-paper': {
    width: '100%',
    maxWidth: 700,
  }
});

export const Row = styled('div')({
  display: 'flex',
  justifyContent: 'space-around',
  padding: '10px 20px'
});

export const Column = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '120px'
});

export const BodyTitle = styled(Typography)({
  color: 'rgb(11,112,99)',
  fontWeight: 500
});

export const PatientLinkComponent = styled('div')({
  display: 'flex',
  padding: '10px 50px',
  background: '#f6f6f6',
  alignItems: 'center',
  borderRadius: '5px',
  flexDirection: 'column',
  margin: '20px 10px'
});

export const PatientLinkWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  '& p': {
    fontSize: '15px'
  }
});

export const DialogTitle = styled(MuiDialogTitle)({
  cursor: 'default',
  padding: '20px 0px 15px 25px'
});

export const LinkButton = styled(LinkButtonShared)({
  margin: 0,
  padding: 0,
  color: '#000',
  textDecoration: 'none'
});
